import { BoardsStoreRequest } from 'src/api/BoardsStoreRequest';
import apiClient from './core/ApiClient'
import { Board } from 'src/api/Board';
import { BoardsFindResponse } from 'src/api/BoardsFindResponse';
import { BoardCard } from 'src/api/BoardCard';
import { LanesStoreRequest } from 'src/api/LanesStoreRequest';
import { LanesFindResponse } from 'src/api/LanesFindResponse';

const root = '/api/boards';

const update = (board: Board): Promise<void> => {
    let payload: BoardsStoreRequest = {
        board: board
    }
    return apiClient.put<BoardsStoreRequest, void>(root, payload);
}

const findWithUsers = (name: string): Promise<BoardsFindResponse> => apiClient.get<BoardsFindResponse>(`${root}/${name}`);

const findLane = (name: string): Promise<BoardCard[]> => apiClient.get<LanesFindResponse>(`${root}/lanes/${name}`).then(r => r.lane.concat([]));

const archive = (card: BoardCard): Promise<void> => {
    let payload: LanesStoreRequest = {
        card: card
    };
    return apiClient.post<LanesStoreRequest, void>(`${root}/lanes/archive`, payload);
}
const deleteFromLane = (name: string, cardId: string): Promise<void> => apiClient.delete<void>(`${root}/lanes/${name}/${cardId}`)
const moveToLane = (name: string, cardId: string): Promise<void> => apiClient.put(`${root}/lanes/${name}/${cardId}`, undefined)

export const boardService = {
    update,
    findWithUsers,
    findLane,
    archive,
    deleteFromLane,
    moveToLane
}
